export function getNumberRangeTags({ max, min, t }) {
  const unbounded = t('Filter.NumberRangeUnboundedKey')

  return min || max
    ? [
        {
          label: t('Filter.NumberRangeTagKey', {
            max: max || unbounded,
            min: min || unbounded,
          }),
        },
      ]
    : null
}
